module.exports = __webpack_public_path__ + "img/2.90cc15ff.png";